import $ from '../Common/wrapper.js';

/**
 * Controls sidebar behavior
 *     [router] Used to change url when using collapsed modes
 *     [closeSidebar] callback to close sidebar using vuex
 */
export default (router, closeSidebar) => {

    var $body = $('body');
    var $sidebar = $('.sidebar');

    // AUTOCOLLAPSE ITEMS
    // -----------------------------------

    var sidebarCollapse = $sidebar.find('.collapse');
    sidebarCollapse.on('show.bs.collapse', function(event) {

        event.stopPropagation();
        if ($(this).parents('.collapse').length === 0)
            sidebarCollapse.filter('.show').collapse('hide');

    });

    // SIDEBAR COLLAPSED ITEM HANDLER
    // -----------------------------------


    var eventName = isTouch() ? 'click' : 'mouseenter';
    var subNav = $();
    $sidebar.find('.sidebar-nav > li').on(eventName, function() {

        if (isSidebarCollapsed() || useAsideHover()) {

            subNav.trigger('mouseleave');
            subNav = toggleMenuItem($(this));

            // Used to detect click and touch events outside the sidebar
            sidebarAddBackdrop();
        }

    });

    var sidebarAnyclickClose = $sidebar.data('sidebarAnyclickClose');

    // Allows to close
    if (typeof sidebarAnyclickClose !== 'undefined') {

        $('.wrapper').on('click.sidebar', function(e) {
            // don't check if sidebar not visible
            if (!$body.hasClass('aside-toggled')) return;

            var $target = $(e.target);
            if (!$target.parents('.aside-container').length && // if not child of sidebar
                !$target.parents('.topnavbar-wrapper').length && // if not child of header
                !$target.is('#user-block-toggle') && // user block toggle anchor
                !$target.parent().is('#user-block-toggle') // user block toggle icon
            ) {
                closeSidebar()
            }

        });
    }

    // auto close open submenu when route changes
    router.afterEach(removeFloatingNav)

    function sidebarAddBackdrop() {
        var $backdrop = $('<div/>', { 'class': 'sidebar-backdrop' });
        $backdrop.insertAfter('.aside-container').on("click mouseenter", function() {
            removeFloatingNav();
        });
    }

    // Open the collapse sidebar submenu items when on touch devices
    // - desktop only opens on hover
    function toggleTouchItem($element) {
        $element
            .siblings('li')
            .removeClass('open');
        $element
            .toggleClass('open');
    }

    // Handles hover to open items under collapsed menu
    // -----------------------------------
    function toggleMenuItem($listItem) {

        removeFloatingNav();

        var ul = $listItem.find('.sidebar-nav');

        if (!ul.length) return $();
        if ($listItem.hasClass('open')) {
            toggleTouchItem($listItem);
            return $();
        }

        var $aside = $('.aside-container');

        var subNav = ul.clone().appendTo($aside);

        toggleTouchItem($listItem);

        subNav.find('a')
            .on('click.subnav', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');

                if(href.indexOf('http') === 0){
                    window.open(href);
                    return;
                }
                //avoid NavigationDuplicated exception if clicking on current link
                if (router.currentRoute.path !== href){
                    if (e.ctrlKey === true) {
                        // if click + ctrl
                        window.open(href, '_blank');
                    }
                    else{
                        router.push(href);
                    }
                }
            })
        subNav.addClass('nav-floating');

        // Apply position:fixed first so the popup re-flows to its final width
        // (the cloned <ul> would otherwise size to the narrow sidebar column,
        // making outerHeight too tall and leaving a gap below the button).
        subNav.css({
                position: 'fixed',
                top: 0,
                bottom: 'auto',
                visibility: 'hidden'
            });

        // Now measure with the popup in its final layout state.
        // Rule: popup top aligns with item top when it fits below; otherwise
        // popup bottom aligns with item bottom (going up).
        var itemRect = $listItem[0].getBoundingClientRect();
        var subNavHeight = subNav[0].getBoundingClientRect().height;
        var vwHeight = document.documentElement.clientHeight;
        var fitsBelow = itemRect.top + subNavHeight <= vwHeight;
        var top = fitsBelow ? itemRect.top : itemRect.bottom - subNavHeight;
        // Don't allow popup to overflow the top of the viewport.
        if (top < 0) top = 0;

        subNav.css({
                top: top,
                visibility: ''
            });

        subNav.on('mouseleave', function() {
            toggleTouchItem($listItem);
            subNav.remove();
        });

        return subNav;
    }

    function removeFloatingNav() {
        $('.sidebar-subnav.nav-floating').remove();
        $('.sidebar-backdrop').remove();
        $('.sidebar li.open').removeClass('open');
    }

    function isTouch() {
        return 'ontouchstart' in window || navigator.msMaxTouchPoints;
    }

    function isSidebarCollapsed() {
        return $body.hasClass('aside-collapsed') || $body.hasClass('aside-collapsed-text');
    }
    /*function isSidebarToggled() {
        return $body.hasClass('aside-toggled');
    }
    function isMobile() {
        return document.body.clientWidth < APP_MEDIAQUERY.tablet;
    }*/
    // function isFixed() {
    //     return $body.hasClass('layout-fixed');
    // }

    function useAsideHover() {
        return $body.hasClass('aside-hover');
    }

} // rendered